<template>
  <div class="loginD" v-loading="loading">
    <div ref="header"><Header ref="log" @isShowLogin="isShowLogin" @isShowJBrLogin="isShowJBrLogin" /></div>
    <div class="banner flex-center-align flex-column" :style="{ minHeight: minHeight + 'px' }">
      <!-- <img class="imgLogo" src="../../assets/images/dashboard/LOGONew.png" height="81" /> -->
      <div class="icon">
        <el-row type="flex" justify="center">
          <div v-for="(item, i) in routerIcons" :span="2" :key="i">
            <el-col class="padding" @click.native="next(item.path, item.title)">
              <img :src="item.img" height="80" width="80" />
              <div class="mt-base">{{ item.title }}</div>
            </el-col>
          </div>
        </el-row>
      </div>
    </div>
    <div ref="footer"><Footer /></div>
    <el-dialog :close-on-click-modal="false" :visible.sync="isShow" width="360px">
      <LoginDialog />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowJBr" width="360px">
      <loginCaDialog />
    </el-dialog>
  </div>
</template>

<script>
import Header from './header/index.vue';
import Footer from '../../layout/Footer.vue';
import { localDataUser } from '@/pages/iebdc/utils/local-data.js';
import LoginDialog from './LoginDialog';
import loginCaDialog from './loginCaDialog';
import { mapGetters } from 'vuex';
import bsdtDialog from '@iebdc/mixin/bsdtDialog';
import applicantFinishService from '@/pages/iebdc/api/apply/applicant-finish';
//获取经办人列表
import { getAgentUserList } from 'iebdc/api/my-operator';
export default {
  name: 'index',
  components: {
    Header,
    Footer,
    LoginDialog,
    loginCaDialog,
  },
  mixins: [bsdtDialog],
  data() {
    return {
      minHeight: '',
      isShow: false,
      isShowJBr: false,
      userData: localDataUser.get(),
      gsggurl: '',
      routerIcons: [
        {
          img: require('../../assets/images/dashboard/djbl.png'),
          title: '登记办理',
          path: '/home/check-in',
          permission: 'IEBDC:SY:DJBL',
        },
        {
          img: require('../../assets/images/dashboard/xxcx.png'),
          title: '信息查询',
          path: '/home/info-search',
          permission: 'IEBDC:SY:XXCX',
        },
        {
          img: require('../../assets/images/dashboard/wsyy.png'),
          title: '网上预约',
          path: '/home/appointment',
          permission: 'IEBDC:SY:WSYY:WYYY',
        },
        {
          img: require('../../assets/images/dashboard/gsgg.png'),
          title: '公示公告',
          path: '/home/xxfw/public-announcement',
          permission: 'IEBDC:SY:XXFW:GSGG',
        },
        {
          img: require('../../assets/images/dashboard/bszn.png'),
          title: '办事指南',
          path: '/home/xxfw/guidance',
          permission: 'IEBDC:SY:XXFW:BSZN',
        },
        {
          img: require('../../assets/images/dashboard/zcfg.png'),
          title: '政策法规',
          path: '/home/xxfw/policy-law',
          permission: 'IEBDC:SY:XXFW:ZCFG',
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['selectedBsdtCode', 'selectedBsdtTitle']),
    isLogined() {
      return !this.userData;
    },
  },
  mounted() {
    this.contentBoxH();
    window.onresize = () => {
      this.contentBoxH();
    };
    if (this.userData) {
      //切换成企业用户后获取之前保存的经办人
      if (
        this.userData.hasOwnProperty('jbrListData') &&
        !this.$store.getters['jbrlist-data/getJbrListData'].hasOwnProperty('institutionaluser')
      ) {
        this.$store.commit('jbrlist-data/setJbrListData', this.userData.jbrListData);
      }
      //个人用户登录获取经办人
      console.log(this.userData.userType == 'gr' && !window.jbrname && !this.userData.hasOwnProperty('jbrListData'));
      if (this.userData.userType == 'gr' && !window.jbrname && !this.userData.hasOwnProperty('jbrListData')) {
        window.jbrname = 'jbr';
        getAgentUserList({ name: this.userData.name, sfzh: this.userData.zjh }).then((res) => {
          if (res.success && res.data) {
            //经办人无公司信息返回时,没有页面弹出
            if (res.data.hasOwnProperty('institutionaluser') && res.data.institutionaluser.length > 0) {
              //将经办人信息放入vuex
              this.$store.commit('jbrlist-data/setJbrListData', res.data);
              this.$nextTick(() => {
                this.$jbr();
              });
            }
          } else {
            // this.$message.error(res.message)
          }
        });
      }
      //是否活体实名
      if (Number(this.userData.realNameStatus) != 1) {
        // //获取二维码
        // if (this.userData.agentUser) {
        //   this.$slsm();
        //   //this.$refs.slsm.getsmEwm();
        // } else if (this.userData.userCategory === 'NORMAL') {
        //   this.$slsm();
        //   //this.$refs.slsm.getsmEwm();
        // } else {
        //   this.$refs.qyrz.dialogVisible = true;
        // }
        // this.$qyrz();
      }
    }
  },
  methods: {
    contentBoxH() {
      let screeHeight = document.documentElement.clientHeight || document.body.clientHeight;
      let headerHeight = this.$refs.header.offsetHeight;
      // let footerHeight = this.$refs.footer.offsetHeight;
      let footerHeight = 148;
      let height = screeHeight - headerHeight - footerHeight;
      if (height <= 360) {
        height = 360;
      }
      this.minHeight = height;
    },
    //图标的下一步
    next(path, title) {
      // 办事指南、政策法规、公示公告未登录也可查看。办事指南,所有配置流程全部显示，未登录不可办理，登陆后，后台设置为不展示的也不可办理
      if (title === '公示公告') {
        //公示公告先选择办事大厅，获取外链地址
        if (!this.bsdtDialog()) {
          return;
        }
        this.getBsdtDetail(path);
        return;
      }
      if (title === '办事指南' || title === '政策法规') {
        this.$router.push(path);
        return;
      }
      //图标跳转
      if (this.isLogined === false) {
        if (!this.bsdtDialog()) {
          return;
        }
        this.$router.push(path);
        //this.loading = true;
      } else {
        if (this.$hasPermission('IEBDC:DL:TYRZ')) {
          this.$confirm('', '提示', {
            confirmButtonText: '立马登录',
            cancelButtonText: '暂不登录',
            type: 'warning',
            center: true,
          })
            .then(() => {
              this.$refs.log.goNxlogin();
            })
            .catch();
        } else {
          this.isShow = true;
        }
      }
    },
    //获取办事大厅详情
    async getBsdtDetail(path) {
      const { success, data } = await applicantFinishService.getBsdtDetail({ officeCode: this.selectedBsdtCode });
      if (success && data) {
        //配置了公示公告外链则直接跳转
        if (data.gsggurl) {
          window.open(data.gsggurl);
        } else {
          this.$router.push(path);
        }
      } else {
        this.$router.push(path);
        this.$message.error(data.message);
      }
    },
    isShowLogin() {
      this.isShow = true;
    },
    isShowJBrLogin() {
      this.isShowJBr = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/pages/iebdc/styles/common-variables.scss';
@import '~@/pages/iebdc/styles/public.scss';
.banner {
  width: 100%;
  background: url(../../assets/images/dashboard/bgNew.png) no-repeat center center;
  background-size: 100% 100%;
  padding: 50px 0;
  position: relative;
  .mb-42 {
    margin-bottom: 42px;
  }
  img.imgLogo {
    height: 70px;
    width: auto;
  }
  .btn {
    /deep/ .el-button {
      color: #ffffff;
      border-radius: 4px;
      box-shadow: 1px 1px 1px 0 rgba(0, 29, 50, 0.45);
      font-size: 20px;
      &:nth-child(1) {
        background-color: #2c8cff;
        border-color: #2c8cff;
      }
      &:nth-child(2) {
        background-color: #4a8cbc;
        border-color: #4a8cbc;
      }
    }
  }
  .icon {
    background-color: rgba(255, 255, 255, 0.6);
    position: absolute;
    left: 0;
    top: 60%;
    margin-top: -71px;
    width: 100%;
    border-radius: 4px;
    padding: $spacing-medium;
    color: #333333;
    font-size: 16px;
    font-family: Microsoft YaHei, serif;

    .el-col {
      -webkit-transition: -webkit-transform 0.2s;
      -moz-transition: -moz-transform 0.2s;
      transition: transform 0.2s;
      text-align: center;
      &:hover {
        cursor: pointer;
        transform: scale(1.1, 1.1);
      }
    }
  }
  .padding {
    padding: 0px 20px;
  }
  .mt-base {
    margin-top: $spacing-base;
    font-size: 20px;
  }

  @media screen and (max-width: 1380px) {
    img.imgLogo {
      height: 60px;
      width: auto;
    }
    .icon {
      top: 60%;
    }
  }
}
/deep/ .login-dialog {
  /deep/ .el-dialog {
    width: 27%;
  }
}
.loginD /deep/ {
  .el-dialog__body {
    position: relative;
    //height: 440px;
    padding: 20px 20px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #282828;
    font-size: 20px;
  }
}
</style>
